import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import { useMap } from 'react-leaflet';

interface IProps {
  actingId: string;
  plannedRoute: L.LatLngExpression[];
  analyzedTraceSegments: L.LatLngExpression[][];
}

const ActingRouteMapBounds: React.FC<IProps> = ({
  actingId,
  plannedRoute,
  analyzedTraceSegments,
}) => {
  const map = useMap();
  const framedActingId = useRef<string>();

  useEffect(() => {
    if (framedActingId.current === actingId) return;

    const positions = plannedRoute.length
      ? plannedRoute
      : analyzedTraceSegments.flat();
    if (!positions.length) return;

    framedActingId.current = actingId;

    if (positions.length === 1) {
      map.setView(positions[0], 17);
      return;
    }

    map.fitBounds(L.latLngBounds(positions), { padding: [40, 40] });
  }, [actingId, analyzedTraceSegments, map, plannedRoute]);

  return null;
};

export default ActingRouteMapBounds;
